import usePrivateLink from "../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import BaseForm from "./Form";
import { ToastMain, SweetAlertShow } from "../master/Master";
import { fetchCategories, fetchDoc } from "../../api/Documents";
import { imgBaseUrl } from "../../api/api";
import { FiEye } from "react-icons/fi";
import { viewlist } from "../../api/BatchService";
import { getSessions } from "../../api/SessionsService";
import DocumentHeader from "./DocumentHeader";
import { useNavigate } from "react-router-dom";
import { GetMarketingSchool } from "../../api/MarketinService";
import { courseList } from "../../api/Courses";
import { StaffList } from "../../api/Staff";

const DocumentCollection = () => {
  const hasAccess = usePrivateLink();
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [doc, setDoc] = useState("");
  const [docType, setDocType] = useState("");
  const [type, setType] = useState("student");
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [batch, setBatch] = useState();
  const [selectedBatch, setSelectedBatch] = useState("");
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSessions] = useState("");
  // ✅ New state to track selected student
  const [selectedStudent, setSelectedStudent] = useState(null);
  const navigate = useNavigate();
  const [sources, setSources] = useState([]);
  const [courses, setCourses] = useState([]);

  const [selectedSource, setSelectedSource] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState("");

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response?.data?.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1"
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
        // setSessions(activeSessions);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const categoryFetch = async () => {
    setLoading(true);
    try {
      const response = await fetchCategories();
      if (response.data.status) {
        setCategory(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    }
    setLoading(false);
  };

  const getDoc = async () => {
    setLoading(true);
    let addUrl = `&type=${type}&doc_type=${docType}`;
    if (selectedCategory) {
      addUrl += `&category=${selectedCategory}`;
    }
    if (selectedBatch) {
      addUrl += `&batch_id=${selectedBatch}`;
    }
    if (search) {
      addUrl += `&search=${search}`;
    }

    if (type === "student" && selectedBatch) {
      addUrl += `&batch_id=${selectedBatch}`;
    }

    if (type === "marketing" && selectedSource) {
      addUrl += `&source_id=${selectedSource}`;
    }

    if (type === "enquiry" && selectedCourse) {
      addUrl += `&course_id=${selectedCourse}`;
    }
    if (type === "staff" && selectedStaff) {
      addUrl += `&staff_id=${selectedStaff}`;
    }

    try {
      const response = await fetchDoc(addUrl);
      if (response.data?.status) {
        setDoc(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {}
    setLoading(false);
  };

  useEffect(() => {
    categoryFetch();
  }, []);

  useEffect(() => {
    if (type) {
      getDoc();
    }
  }, [type, docType, search, selectedBatch, selectedCategory]);

  const handleDownload = async (url, filename) => {
    try {
      const response = await fetch(url, { mode: "no-cors" });
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename || "document";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed!");
    }
  };

  // ✅ Handle cleanup when offcanvas is hidden
  useEffect(() => {
    const offcanvasEl = document.getElementById("documentOffcanvas");
    if (!offcanvasEl) return;

    const handleHidden = () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };

    offcanvasEl.addEventListener("hidden.bs.offcanvas", handleHidden);

    return () => {
      offcanvasEl.removeEventListener("hidden.bs.offcanvas", handleHidden);
    };
  }, []);

  const fetchBatches = async () => {
    const addUrl = `&session_id=${selectedSession}`;
    setLoading(true);
    try {
      const response = await viewlist(addUrl);
      if (response?.data?.status) {
        setBatch(response.data);
      } else {
        alert("Failed to fetch batches");
      }
    } catch (err) {
      console.error(err);
      alert("Error fetching batches");
    } finally {
      setLoading(false);
    }
  };

  const getSources = async () => {
    const res = await GetMarketingSchool();
    if (res?.data?.status) setSources(res.data.data);
  };

  const getCourses = async () => {
    const res = await courseList();
    if (res?.data?.status) setCourses(res.data.data);
  };

  const fetchStaff = async () => {
    setLoading(true);
    try {
      const res = await StaffList();
      if (res?.data?.status) {
        setStaffList(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedSession) {
      fetchBatches();
    }
  }, [selectedSession]);
useEffect(() => {
    if (type === "student") fetchBatches();
    if (type === "marketing") getSources();
    if (type === "enquiry") getCourses();
    if (type === "staff") fetchStaff();
  }, [type]);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row custom-scroll-layout">
                  <div className="col-md-2 left-pane">
                    <DocumentHeader data={"Documents Portal"} />
                  </div>
                  <div className="col-md-10 right-pane">
                    <div className="card">
                      <div className="card-header align-items-center justify-content-between">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h4 className="text-primary m-0">
                            Document Collection
                          </h4>
                          {hasAccess("/documents/add") && (
                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => navigate("/documents/add")}
                            >
                              Add Doc
                            </button>
                          )}
                        </div>

                        {/* Filters Section */}
                        <div className="row g-3">
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline ">
                              <select
                                className="form-control"
                                name="type"
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                              >
                                <option value="">Type</option>
                                <option value="student">Student</option>
                                <option value="enquiry">Enquiry</option>
                                <option value="marketing">Marketing</option>
                                <option value="staff">Staff</option>
                              </select>
                              <label>Type</label>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline ">
                              <select
                                className="form-control"
                                value={docType}
                                onChange={(e) => setDocType(e.target.value)}
                              >
                                <option value="">Doc_Type</option>
                                <option value="hard">Hard</option>
                                <option value="soft">Soft</option>
                              </select>
                              <label>Doc Type</label>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="mb-3 form-floating form-floating-outline">
                              <select
                                className="form-select"
                                name="category_id"
                                value={selectedCategory}
                                onChange={(e) =>
                                  setSelectedCategory(e.target.value)
                                }
                              >
                                <option>Select Category</option>
                                {category?.data?.map((cat, i) => (
                                  <option key={i} value={cat.id}>
                                    {cat?.title}
                                  </option>
                                ))}
                              </select>
                              <label>Document Category</label>
                            </div>
                          </div>

                          <div className="col-md-3 form-floating form-floating-outline">
                            <select
                              className="form-select"
                              name="session"
                              value={selectedSession}
                              onChange={(e) =>
                                setSelectedSessions(e.target.value)
                              }
                            >
                              {/* <option value="">Select Session</option> */}
                              {sessions?.map((session) => (
                                <option key={session?.id} value={session?.id}>
                                  {session?.session}:
                                  {session?.status == "1"
                                    ? "Active"
                                    : " Inactive"}
                                  {/* Show "2023-24" */}
                                </option>
                              ))}
                            </select>

                            <label>Filter Session</label>
                          </div>

                          {type === "student" && (
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={selectedBatch}
                                  onChange={(e) =>
                                    setSelectedBatch(e.target.value)
                                  }
                                >
                                  <option value="">Select Batch</option>
                                  {batch?.batches?.map((b) => (
                                    <option key={b.id} value={b.id}>
                                      {b.title}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Batch</label>
                              </div>
                            </div>
                          )}

                          {type === "marketing" && (
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={selectedSource}
                                  onChange={(e) =>
                                    setSelectedSource(e.target.value)
                                  }
                                >
                                  <option value="">Select Source</option>
                                  {sources?.map((src) => (
                                    <option key={src.id} value={src.id}>
                                      {src.title}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Source</label>
                              </div>
                            </div>
                          )}

                          {type === "enquiry" && (
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={selectedCourse}
                                  onChange={(e) =>
                                    setSelectedCourse(e.target.value)
                                  }
                                >
                                  <option value="">Select Course</option>
                                  {courses?.map((course) => (
                                    <option key={course.id} value={course.id}>
                                      {course.title}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Course</label>
                              </div>
                            </div>
                          )}

                          {type === "staff" && (
                            <div className="col-md-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={selectedStaff}
                                  onChange={(e) =>
                                    setSelectedStaff(e.target.value)
                                  }
                                >
                                  <option value="">Select Staff</option>
                                  {staffList?.map((staff) => (
                                    <option key={staff.id} value={staff.id}>
                                      {staff.name}
                                    </option>
                                  ))}
                                </select>
                                <label>Select Staff</label>
                              </div>
                            </div>
                          )}

                          <div className="form-floating form-floating-outline col-md-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search"
                              name="search"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                            <label>Search</label>
                          </div>
                        </div>

                        {/* Table Section */}
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Student Name</th>
                                <th>Father Name</th>
                                <th>Mobile</th>
                                <th>Document</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan="5" className="text-center">
                                    {/* <div className="spinner-border" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div> */}
                                    {loading}
                                  </td>
                                </tr>
                              ) : (
                                doc?.data?.map((student, index) => (
                                  <tr key={student?.id}>
                                    <td>{index + 1}</td>
                                    <td>{student?.name}</td>
                                    <td>{student?.father_name}</td>
                                    <td>{student?.phone || "N/A"}</td>
                                    <td>
                                      {hasAccess('/documents/collection/info') && (
                                        <button
                                          className="btn btn-sm btn-outline-primary"
                                          data-bs-target="#editUser"
                                          data-bs-toggle="modal"
                                          onClick={() =>
                                            setSelectedStudent(student)
                                          } // ✅ Set selected student
                                        >
                                          View
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Document Offcanvas */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="documentOffcanvas"
        aria-labelledby="documentOffcanvasLabel"
      >
        <div className="offcanvas-header">
          <h4 id="documentOffcanvasLabel" className="text-primary">
            Add Document
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="col-md-3 mb-3">
            <div
              className="btn-group w-50"
              role="group"
              aria-label="Category selection"
            >
              <input
                type="radio"
                className="btn-check"
                name="category"
                id="enquiry"
                value="enquiry"
                checked={selectedCategory === "enquiry"}
                onChange={(e) => setSelectedCategory(e.target.value)}
              />
              <label
                className={`btn ${
                  selectedCategory === "enquiry"
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
                htmlFor="enquiry"
              >
                Enquiry
              </label>

              <input
                type="radio"
                className="btn-check"
                name="category"
                id="marketing"
                value="marketing"
                checked={selectedCategory === "marketing"}
                onChange={(e) => setSelectedCategory(e.target.value)}
              />
              <label
                className={`btn ${
                  selectedCategory === "marketing"
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
                htmlFor="marketing"
              >
                Marketing
              </label>

              <input
                type="radio"
                className="btn-check"
                name="category"
                id="student"
                value="student"
                checked={selectedCategory === "student"}
                onChange={(e) => setSelectedCategory(e.target.value)}
              />
              <label
                className={`btn ${
                  selectedCategory === "student"
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
                htmlFor="student"
              >
                Student
              </label>
            </div>
          </div>
          <BaseForm defaultCategory={selectedCategory} />
        </div>
      </div>

      {/* View Student Documents Modal */}
      <div
        className="modal fade"
        id="editUser"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-simple modal-edit-user">
          <div className="modal-content">
            <div className="modal-body p-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />

              <div className="text-center mb-6">
                <h4 className="mb-2">View Student Documents</h4>
              </div>

              <div className="container my-4">
                <div
                  className="rounded-4 p-4 mb-5"
                  style={{ maxWidth: "800px", margin: "0 auto" }}
                >
                  <div className="row g-3 mt-3">
                    {loading ? (
                      <div className="col-12 text-center">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : selectedStudent?.documents?.length > 0 ? (
                      selectedStudent.documents.map((document) => (
                        <div className="col-md-6" key={document.id}>
                          <div className="border rounded-4 p-3 h-100 shadow-sm">
                            <h6 className="fw-semibold mb-2">
                              {(
                                document.category?.title ||
                                document.doc_type ||
                                "DOCUMENT"
                              ).toUpperCase()}
                            </h6>

                            <div className="d-flex justify-content-between align-items-center">
                              <img
                                src={`${imgBaseUrl}${document.path}`}
                                alt={document.doc_type || "document"}
                                style={{
                                  height: "60px",
                                  width: "60px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                  border: "1px solid #ddd",
                                }}
                                loading="lazy"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "/no-image.png";
                                }}
                              />

                              <div className="d-flex gap-2">
                                <a
                                  href={`${imgBaseUrl}${document.path}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-sm btn-outline-primary"
                                  title={`View ${
                                    document.doc_type || "Document"
                                  }`}
                                >
                                  <FiEye />
                                </a>

                                <button
                                  onClick={() =>
                                    handleDownload(
                                      `${imgBaseUrl}${document.path}`,
                                      `${document.doc_type || "document"}.jpeg`
                                    )
                                  }
                                  className="btn btn-sm btn-outline-success"
                                >
                                  Download
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p>No documents available.</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentCollection;
